import { normalize } from 'normalizr'
import { pathOr } from 'ramda'
import { arrayOfRates } from '../../rateSchema'

export default rates => {
    const ratesData = pathOr([], ['_embedded', 'bookingRates'], rates)
    return { ...normalize(ratesData, arrayOfRates) }
}



// WEBPACK FOOTER //
// ./src/adapters/parsers/bookingParsers/bookingRates.js